import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { QuizTypesDataService, QuizTypesColumnsService } from '../../../services';
import { QuizType, QuizTypesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-quiz-type-details',
  templateUrl: './quiz-type-details.component.html',
  styleUrls: ['./quiz-type-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class QuizTypeDetailsComponent implements OnInit, OnDestroy {

  public quizType: QuizType = {};
  public quizTypes: QuizType[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private quizTypesDataService: QuizTypesDataService,
    private quizTypesColumnsService: QuizTypesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Quiz Type - Details');
        this.getQuizType(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.quizType !== 'undefined') {
      this.quizType = this.dynamicDialogConfig.data.quizType;
    }
    this.columns = this.quizTypesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getQuizType(id: number): void {
    this.isLoading = true;
    this.quizTypesDataService.getQuizType(id).subscribe((response: QuizType|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.quizType = response;
      }
    });
  }

  list() {
    this.router.navigate(['/quiz-types']);
  }

  add() {
    this.router.navigate(['/quiz-types/add']);
  }

  edit() {
    this.router.navigate(['/quiz-types/edit/' + this.quizType.id]);
  }

}
@Component({
  selector: 'app-quiz-type-details',
  templateUrl: './quiz-type-details.component.html',
  styleUrls: ['./quiz-type-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogQuizTypeDetailsComponent extends QuizTypeDetailsComponent {
}

